export default __webpack_public_path__ + "541bc9f9f9bf60be3e650423e0e2ac7c.svg";